import { createContext, useContext, useState, type ReactNode } from 'react';

interface SearchContextValue {
  term: string;
  setTerm: (term: string) => void;
}

const SearchContext = createContext<SearchContextValue>({ term: '', setTerm: () => undefined });

/**
 * Provides the current global search term to descendant components.
 *
 * @param children - Subtree that can read/update the shared search term via {@link useGlobalSearch}.
 * @returns A context provider wrapping `children`.
 */
export function SearchProvider({ children }: { children: ReactNode }) {
  const [term, setTerm] = useState('');
  return <SearchContext.Provider value={{ term, setTerm }}>{children}</SearchContext.Provider>;
}

/**
 * Accesses the shared global search term and its setter.
 *
 * @returns The current search term and a function to update it.
 */
export function useGlobalSearch() {
  return useContext(SearchContext);
}
